import React from 'react';
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { TrainingCompletion as TrainingCompletionType } from '../../services/analyticsService';

interface Props {
  data: TrainingCompletionType;
}

const DEFAULT_TRAINING_DATA = [
  { name: 'Retail', rate: 18 },
  { name: 'Manufacturing', rate: 26 },
  { name: 'Healthcare', rate: 36 },
  { name: 'Technology', rate: 46 },
  { name: 'Finance', rate: 62 },
];

const TrainingCompletionChart: React.FC<Props> = ({ data }) => {
  const chartData = data?.by_industry?.length
    ? data.by_industry.map((item) => ({
        name: item.industry,
        rate: Math.round(item.completion_rate),
      }))
    : DEFAULT_TRAINING_DATA;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40]">Training &amp; Human Readiness</h2>
      <p className="text-xs text-gray-500 mt-1 mb-3">Training Completion Rate (%)</p>
      <div className="h-36 w-full -ml-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 9, fill: '#64748b' }}
              interval={0}
            />
            <YAxis
              domain={[0, 100]}
              tickLine={false}
              axisLine={false}
              tick={false}
              width={10}
            />
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-md text-xs">
                      <p className="font-bold text-[#0c1e40]">{payload[0].payload.name}</p>
                      <p className="text-blue-600 font-semibold">{payload[0].value}% completion</p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Bar dataKey="rate" fill="#2563eb" radius={[4, 4, 0, 0]} maxBarSize={30} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TrainingCompletionChart;
